import React from 'react';
import parse from 'html-react-parser';

const decodeHtmlEntities = (htmlString) => {
  if (typeof document === 'undefined') return htmlString;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = htmlString;
  return textarea.value;
};

export function safeHTML(htmlString, key) {
  if (typeof htmlString !== 'string') return htmlString;

  const decodedHtml = decodeHtmlEntities(htmlString);

  return (
    <React.Fragment key={key}>
      {parse(decodedHtml, {
        replace(domNode) {
          const { name } = domNode;
          if (name === 'script') return <></>;
          return domNode;
        },
      })}
    </React.Fragment>
  );
}
